export default class formConfig {
  // 招标计划
  static configList() {
    return [
      {
        title: "定标基本情况",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "项目名称：",
            type: "slot",
            value: "prjName",
            slotName: "prjName",
            disabled: true,
            rule: {
              required: true,
              message: "请选择项目名称",
              trigger: "blur"
            }
          },
          {
            label: "招标编号：",
            type: "input",
            value: "tenderReference",
            disabled: true,
            rule: {
              required: true,
              message: "请填写招标编号",
              trigger: "blur"
            }
          },
          {
            label: "定标时间：",
            value: "evaluationStartTime",
            type: "date",
            dateType: "datetime",
            required: true,
            clearable: true,
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            rule: {
              required: true,
              message: "请选择定标时间",
              trigger: "change"
            }
          },
          {
            label: "实际中标人：",
            type: "slot",
            value: "basicInfoName",
            slotName: "basicInfoName",
            disabled: true,
            rule: {
              required: true,
              message: "请选择实际中标人",
              trigger: "blur"
            }
          },
          {
            label: "是否需要递补：",
            type: "select",
            value: "supplement",
            optionData: [
              { name: "否", value: "0" },
              { name: "是", value: "1" },
            ],
            rule: {
              required: true,
              message: "请选择是否需要递补",
              trigger: "blur"
            }
          },
          {
            label: "定标理由：",
            value: "reason",
            type: "textarea",
            required: true,
            maxlength: 1200,
            width: "100%",
            minRows: "3",
            maxRows: "2",
            tip:"(最多填写1200个字)",
            rule: {
              required: true,
              message: "请填定标理由",
              trigger: "blur"
            }
          },
          {
            label: "备注：",
            value: "remarks",
            type: "textarea",
            required: true,
            maxlength: 1200,
            width: "100%",
            minRows: "3",
            maxRows: "2",
            tip:"(最多填写1200个字)",
            rule: {
              required: true,
              message: "请填备注",
              trigger: "blur"
            }
          },
        ]
      },
      {
        title: "定标委员会成员信息",
        name: "2",
        icon: "",
        formConfigList: [
          {
            label: "",
            type: "slot",
            slotName: "committeeList",
            class: "formList"
          },
        ]
      },
      {
        title: "其他",
        name: "3",
        icon: "",
        formConfigList: [
          // {
          //   label: "历史核验记录：",
          //   type: "slot",
          //   slotName: "state",
          // },
          {
            label: "招标人意见：",
            value: "tenderOpinion",
            type: "textarea",
            required: true,
            maxlength: 900,
            minRows: "3",
            maxRows: "2",
            disabled: true,
            width: "100%;"
          },
        ]
      },
    ];
  }
}
